import { Tooltip as DigdirTooltip, } from "@digdir/designsystemet-react";
const Tooltip = DigdirTooltip;
Tooltip.displayName = "Tooltip";
export { Tooltip };
//# sourceMappingURL=tooltip.js.map